import { render, staticRenderFns } from "./MarketShowItem.vue?vue&type=template&id=1b402ef5&scoped=true&"
import script from "./MarketShowItem.vue?vue&type=script&lang=ts&"
export * from "./MarketShowItem.vue?vue&type=script&lang=ts&"
import style0 from "./MarketShowItem.vue?vue&type=style&index=0&id=1b402ef5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b402ef5",
  null
  
)

export default component.exports